import tableRelatedRoomTags from './tableRelatedRoomTags';

export default {
  title: 'Available tags',
  attributeName: 'appTags',
  getURL: 'appId/roommanualtags',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['appId'],
  tableConfig: tableRelatedRoomTags
};
